import { gql, useQuery } from '@apollo/client';
import { GetAdminsQuery } from '../types/types';

export const getAdmin = gql`
  query GetAdmins {
    getAdmins {
      avatar
    }
  }
`;

export function useGetAdmins() {
  const { data: result, loading, error, refetch } = useQuery<GetAdminsQuery>(getAdmin);

  return {
    data: !loading ? result?.getAdmins : null,
    loading,
    error,
    refetch,
  };
}
